export const VERIFICATION_STATUS = {
  IDLE: "idle",
  VERIFIED: "verified",
  UNVERIFIED: "unverified",
};

export const PHONE_VERIFICATION_STATUS = VERIFICATION_STATUS;
